import React from 'react'

export const Education = () => {
    return (
        
<div className="container mt-14 xl:mt-20 mb-14 ">
<h1 className="text-center sm:text-4xl text-3xl font-bold title-font underline">Education</h1>
          <div
            className="flex flex-col md:grid grid-cols-9 mx-auto p-2 text-blue-200"
          >
          
            <div className="flex flex-row-reverse md:contents">
              <div
                className="bg-transparent col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto shadow-md"
              >
                <h3 className="font-semibold bg-transparent text-lg mb-1"> Shivalik college of engineering</h3>
                <p className="lading-tight text-justify bg-transparent font-semibold">
                    Bachelor's Degree in Computer Science & Engineering
                    (2018 - current)
                 </p>
              </div>
              <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
                <div className="h-full w-6 flex items-center justify-center">
                  <div className="h-full w-1 bg-blue-800 pointer-events-none"></div>
                </div>
                <div
                  className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-blue-500 shadow"
                ></div>
              </div>
            </div>
           
            <div className="flex md:contents ">
              <div className="col-start-5 col-end-6 mr-10 md:mx-auto relative">
                <div className="h-full w-6 flex items-center justify-center">
                  <div className="h-full w-1 bg-blue-800 pointer-events-none"></div>
                </div>
                <div
                  className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-blue-500 shadow"
                ></div>
              </div>
              <div
                className="bg-transparent col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto shadow-md"
              >
                <h3 className="font-semibold text-lg mb-1 bg-transparent"> Vivekanand Inter College</h3>
                <p className="leading-tight text-justify bg-transparent">
                Intermediate of Science (State Board)
                (2015 - 2017)
                </p>
              </div>
            </div>
            
            <div className="flex flex-row-reverse md:contents ">
              <div
                className="bg-transparent col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto shadow-md"
              >
                <h3 className="font-semibold text-lg mb-1 bg-transparent">Vivekanand Vidya Mandir Inter College</h3>
                <p className="leading-tight text-justify bg-transparent">
                High School (State Board)
                (2013 - 2015)
                </p>
              </div>
              <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
                <div className="h-full w-6 flex items-center justify-center">
                  <div className="h-full w-1 bg-blue-800 pointer-events-none"></div>
                </div>
                <div
                  className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-blue-500 shadow"
                ></div>
              </div>
            </div>
           
    
           
     
          </div>
        </div>
    )
}
